import React from 'react';
import { Modal } from 'react-bootstrap';
import BillingInfo from './BillingInfo.jsx';

function BillingInfoModal(props) {


    return (
        <Modal show={props.show}>

            <Modal.Header closeButton onHide={props.hide}>
                <Modal.Title>
                    Billing Info
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>

                <div className="row">

                    <div className="col-lg-12">

                        {BillingInfo.description(props.stripeCustomer)}

                        <BillingInfo
                            stripeCustomer={props.stripeCustomer}
                            changeCover={props.changeCover}
                            changeStripeCustomer={props.changeStripeCustomer}
                            afterSubmit={props.hide}
                        />

                    </div>

                </div>

            </Modal.Body>
        </Modal>
    );

}

export default BillingInfoModal;


// WEBPACK FOOTER //
// ./src/components/_global/BillingInfoModal.jsx